export const UPDATE_ACTIVE_ITEM = "UPDATE_ACTIVE_ITEM";



// WEBPACK FOOTER //
// ./src/types/globalTypes.js